import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { TranscriptionService } from '../service/transcription.service';
import { UserService } from 'src/app/pages/user/service/user.service';
import { ClientService } from 'src/app/pages/client/service/client.service';
import { SkillService } from 'src/app/common/services/skill/skill.service';
import { Router } from '@angular/router';
import {
  GetUserResponse,
  GetUserRequest,
} from 'src/app/pages/user/service/models/user.service.model';
import {
  GetClientRequest,
  GetClientsResponse,
  GetSkillResponse,
} from 'src/app/pages/client/models/client.model';
import { ButtonColorEnum } from 'src/app/shared/buttons/enums/button-color.enum';
import { InputTypeEnum } from 'src/app/shared/input/enums/input-type.enum';
import { MaskTypeEnum } from 'src/app/shared/input/enums/mask-type.enum';
import { StatusEnum } from 'src/app/common/utils/status-enum.models';
import { StorageService } from 'src/app/common/services/storage/storage.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, tap, catchError, of } from 'rxjs';

@Component({
  selector: 'app-transcription-new',
  templateUrl: './transcription-new.component.html',
  styleUrls: ['./transcription-new.component.scss'],
})
export class TranscriptionNewComponent implements OnInit {
  constructor(
    public formBuilder: FormBuilder,
    public router: Router,
    public transcriptionService: TranscriptionService,
    public userService: UserService,
    public clientService: ClientService,
    public skillService: SkillService,
    private storageService: StorageService,
    private toastrService: ToastrService
  ) {}
  @Output() selectionChange = new EventEmitter<any>();

  transcriptionId: string = '';
  loadingRequest: boolean = false;
  isAudioSelected: boolean = false;
  isBtnSendEnable: boolean = false;

  attendants: string[] = [];
  selectedAttendant: string[] = [];
  selectedAttendantId: string = '';
  originalAttendants: GetUserResponse[] = [];

  loadingAttendants: boolean = false;
  loadingMoreAttendants: boolean = false;
  loadingSearchAttendants: boolean = false;
  totalItemsAttendants: number = 0;
  attendantsFilter = {
    pageNumber: 1,
    pageSize: 10,
    status: [StatusEnum.ATIVO],
    profiles: ['ATENDENTE'],
    sortAscending: true,
    sortBy: 'Name',
  } as GetUserRequest;

  clients: string[] = [];
  selectedClient: string[] = [];
  selectedClientId: string = '';
  originalClients: GetClientsResponse[] = [];
  loadingClients: boolean = false;
  loadingSearchClients: boolean = false;
  loadingMoreClients: boolean = false;
  totalItemsClients: number = 0;
  clientFilter = {
    pageNumber: 1,
    pageSize: 10,
    status: [StatusEnum.ATIVO],
    sortAscending: true,
    sortBy: 'Name',
  } as GetClientRequest;

  skillOptions: string[] = [];
  selectedSkill: string[] = [];
  selectedSkillId: string = '';
  originalSkills: GetSkillResponse[] = [];
  typeTranscription: string = '';

  transcriptionTypeOptions: string[] = ['Chat', 'Áudio'];

  form = this.formBuilder.group({
    monitor: [''],
    serviceDateTime: ['', Validators.required],
    protocolNumber: ['', Validators.required],
    attendant: [''],
    extension: [''],
    client: ['', Validators.required],
    skillId: [''],
    audio: [{} as File],
    chat: [''],
    transcriptionType: ['', Validators.required],
  });

  error: boolean = false;

  showModalResponse: boolean = false;
  titleModalResponse: string = '';
  iconButtonModalResponse: string = '';
  message: string = '';

  ngOnInit(): void {
    this.updateButtonState();

    let userName = this.storageService.getUser().name;
    this.form.controls.monitor.setValue(userName);

    this.form.controls.client.valueChanges.subscribe((value: string | null) => {
      if (value) {
        let clientId = this.getClientIdFromText(value);

        this.skillOptions =
          this.originalClients
            .find((i) => i.id === clientId)
            ?.skills.map((i) => i.code + ': ' + i.cell + ' — ' + i.subCell) ??
          [];

        if (this.skillOptions.length)
          this.form.controls.skillId.setValidators(Validators.required);
        else this.form.controls.skillId.clearValidators();

        this.form.controls.skillId.updateValueAndValidity();
        this.updateButtonState();
      } else {
        this.skillOptions = [];
        this.selectedSkill = [];
      }
    });

    this.getAttendants(null);
    this.getClients(null);
  }

  get ButtonColorEnum() {
    return ButtonColorEnum;
  }

  get InputTypeEnum() {
    return InputTypeEnum;
  }

  public get MaskTypeEnum() {
    return MaskTypeEnum;
  }

  handleNavigateToList() {
    this.router.navigate(['transcription']);
  }

  getAttendants(name: string | null) {
    this.attendantsFilter.pageNumber = 1;

    if (name) {
      this.attendantsFilter.name = name;
      this.loadingSearchAttendants = true;
    } else {
      this.loadingAttendants = true;
      this.attendantsFilter.name = null;
    }

    this.userService.get(this.attendantsFilter).subscribe({
      next: (data) => {
        this.originalAttendants = data.items;
        this.attendants = data.items.map(
          (attendant) => attendant.name + ' | ' + attendant.functional
        );
        this.totalItemsAttendants = data.totalItems;
        this.loadingAttendants = false;
        this.loadingSearchAttendants = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar os atendentes.');
        this.loadingAttendants = false;
        this.loadingSearchAttendants = false;
      },
    });
  }

  getMoreAttendants() {
    if (this.totalItemsAttendants != this.attendants.length) {
      this.loadingMoreAttendants = true;
      if (this.attendantsFilter.pageNumber)
        this.attendantsFilter.pageNumber += 1;

      this.userService.get(this.attendantsFilter).subscribe({
        next: (data) => {
          this.originalAttendants = this.originalAttendants.concat(data.items);
          this.attendants = this.attendants.concat(
            data.items.map(
              (attendant) => attendant.name + ' | ' + attendant.functional
            )
          );
          this.totalItemsAttendants = data.totalItems;
          this.loadingMoreAttendants = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar os atendentes.');
          this.loadingMoreAttendants = false;
        },
      });
    }
  }

  getClients(name: string | null) {
    this.clientFilter.pageNumber = 1;

    if (name) {
      this.clientFilter.name = name;
      this.loadingSearchClients = true;
    } else {
      this.loadingClients = true;
      this.clientFilter.name = null;
    }

    this.clientService.get(this.clientFilter).subscribe({
      next: (data) => {
        this.originalClients = data.items;
        this.clients = data.items.map((i) => i.name + ' | ' + i.cnpj);
        this.totalItemsClients = data.totalItems;
        this.loadingClients = false;
        this.loadingSearchClients = false;
      },
      error: () => {
        this.toastrService.error('Não foi possível carregar os clientes.');
        this.loadingClients = false;
        this.loadingSearchClients = false;
      },
    });
  }

  getMoreClients() {
    if (this.totalItemsClients != this.clients.length) {
      this.loadingMoreClients = true;
      if (this.clientFilter.pageNumber) this.clientFilter.pageNumber += 1;

      this.clientService.get(this.clientFilter).subscribe({
        next: (data) => {
          this.originalClients = this.originalClients.concat(data.items);
          this.totalItemsClients = data.totalItems;
          this.clients = this.clients.concat(
            data.items.map((i) => i.name + ' | ' + i.cnpj)
          );
          this.loadingMoreClients = false;
        },
        error: () => {
          this.toastrService.error('Não foi possível carregar os clientes.');
          this.loadingMoreClients = false;
        },
      });
    }
  }

  getClientIdFromText(text: string): string {
    if (!text) return '';
    let clientName = text.split('|')[0].trim();
    let client = this.originalClients.find(
      (i) => i.name.trim() === clientName.trim()
    );
    if (client) return client.id;
    else return '';
  }

  getSkillIdFromText(text: string): string | null {
    if (!text || text.trim() === '') return null;

    var [code, cellAndSubCell] = text.split(':').map((part) => part.trim());
    var [cell, subCell] = cellAndSubCell.split('—').map((part) => part.trim());
    var skills = this.originalClients.map((i) => i.skills).flat();

    var skill = skills.find(
      (i) =>
        i.code.toString() === code &&
        i.cell.trim() === cell &&
        i.subCell.trim() === subCell
    );
    return skill ? skill.id : null;
  }

  getSkillIdFromTextAndClientId(text: string, clientId: string): string | null {
    if (!text || text.trim() === '' || !clientId || clientId.trim() === '')
      return null;

    var objClient = this.originalClients.find((i) => i.id === clientId);

    if (!objClient) return null;

    var [code, cellAndSubCell] = text.split(':').map((part) => part.trim());
    var [cell, subCell] = cellAndSubCell.split('—').map((part) => part.trim());

    var skill = objClient.skills.find(
      (i) =>
        i.code.toString() === code &&
        i.cell.trim() === cell &&
        i.subCell.trim() === subCell
    );
    return skill ? skill.id : null;
  }

  getAttendantIdFromText(text: string): string | null {
    if (!text || text.trim() === '') return null;
    let [name, functional] = text.split('|').map((part) => part.trim());
    let attendant = this.originalAttendants.find(
      (i) => i.functional.toString() === functional
    );

    return attendant ? attendant.id : null;
  }

  handleCreateTranscription() {
    if (this.loadingRequest) return;

    this.loadingRequest = true;
    this.error = false;

    let attendantId = this.getAttendantIdFromText(
      this.form.controls.attendant.value ?? ''
    );
    let clientId = this.getClientIdFromText(
      this.form.controls.client.value ?? ''
    );
    let skillId = this.getSkillIdFromTextAndClientId(
      this.form.controls.skillId.value ?? '',
      clientId ?? ''
    );

    let formData: FormData = new FormData();
    formData.append('monitor', this.form.controls.monitor.value ?? '');
    formData.append('skill', skillId ?? '');
    formData.append('clientId', clientId ?? '');
    formData.append(
      'protocolNumber',
      this.form.controls.protocolNumber.value ?? ''
    );
    formData.append(
      'serviceDate',
      this.form.controls.serviceDateTime.value ?? ''
    );
    formData.append('attendant', attendantId ?? '');
    formData.append('extension', this.form.controls.extension.value ?? '');

    if (this.isAudioSelected) {
      formData.append('type', '0');
      formData.append('audio', this.form.controls.audio.value ?? '');
    } else {
      formData.append('type', '1');
      formData.append('conversationText', this.form.controls.chat.value ?? '');
    }

    this.transcriptionService.submit(formData).subscribe({
      next: () => {
        this.loadingRequest = false;
        this.toastrService.success('Atendimento registrado com sucesso');
        this.router.navigate(['transcription']);
      },
      error: (e) => {
        this.loadingRequest = false;
        this.error = true;
        console.error(e);

        this.titleModalResponse = 'Ocorreu um erro ao registrar atendimento';
        this.iconButtonModalResponse = 'assets/icons/error.svg';
        this.message = e.error ?? 'descrição não especificada.';
        this.showModalResponse = true;
      },
    });
  }

  isSkillDisabled(): boolean {
    var client = this.form.controls.client;
    return (
      !client ||
      !client.value ||
      client.value.length == 0 ||
      (client.value.length == 1 && client.value[0] === '')
    );
  }

  getSkillPlaceholder(): string {
    var client = this.form.controls.client;
    if (
      client &&
      client.value &&
      client.value.length > 0 &&
      client.value[0] !== ''
    ) {
      return this.skillOptions.length > 0
        ? 'Selecione a skill'
        : 'Nenhuma skill disponível';
    }
    return 'Requer cliente selecionado';
  }

  getTypePlaceholder(): string {
    if (this.typeTranscription === '') return 'Selecione o tipo de transcrição';
    else return '';
  }

  handleCloseModalResponse() {
    if (this.error == false) this.handleCloseModal();

    this.showModalResponse = false;
  }

  handleCloseModal() {
    this.form.reset();
    this.router.navigate(['/transcription']);
  }

  onOptionSelected(event: any) {
    this.selectionChange.emit(event);

    if (this.typeTranscription === event) this.typeTranscription = '';
    else {
      this.typeTranscription = event;
      this.isAudioSelected = event !== 'Chat';
    }

    this.updateButtonState();
    this.form.controls.chat.setValue('');
  }

  updateButtonState(): boolean {
    this.onTypeSelected();
    let isBufferData: boolean = false;

    if (this.isAudioSelected) {
      isBufferData = this.form.controls.audio.value?.name !== undefined;
    } else {
      isBufferData = !!(
        this.form.controls.chat.value &&
        this.form.controls.chat.value.toString().length > 0
      );
    }

    this.isBtnSendEnable =
      this.loadingAttendants === false &&
      this.loadingClients === false &&
      isBufferData === true &&
      this.typeTranscription !== '' &&
      this.getRequiredFields() === true;

    return this.isBtnSendEnable;
  } 

  onOptionSendEnabled(event: any) {
    this.updateButtonState();
  }

  onTypeSelected(): boolean {
    return this.typeTranscription === '';
  }

  getRequiredFields(): boolean {
    const skillIdControl = this.form.controls.skillId;
    const hasRequiredValidator = skillIdControl.hasValidator(
      Validators.required
    );
    const isSkillIdValid = hasRequiredValidator
      ? skillIdControl.value !== undefined
      : true;

    let isFormValid: boolean =
      this.form.controls.serviceDateTime.value !== '' &&
      this.form.controls.protocolNumber.value !== '' &&
      this.form.controls.attendant.value !== undefined &&
      this.form.controls.client.value !== undefined &&
      isSkillIdValid;

    return isFormValid;
  }

  isControlRequired(control: AbstractControl): boolean {
    const validator = control.validator
      ? control.validator({} as AbstractControl)
      : null;
    return validator ? validator['required'] : false;
  }
}
